import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { ElementoPrimarioGenericoService } from "../../services/ElementoPrimarioGenericoService";

export default {
    name: "GerenciarElementosPrimariosGenericos",
    components: {
        Breadcrumb,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciar EP. Genérico',
                disabled: true
            }
        ],
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Exercício', align: 'center', value: 'exercicio', width: '150px' },
            { text: 'Gerência', align: 'center', value: 'gerencia', width: '120px' },
            { text: 'Descrição', align: 'center', value: 'descricao', width: '300px' },
            { text: 'Origem', align: 'center', value: 'origem', width: '120px' },
            { text: 'Ação', align: 'center', value: 'acao', width: '100px' },
            { text: 'Elemento Item', align: 'center', value: 'elemento_item', width: '150px' },
            { text: 'Valor Total Previsto', align: 'center', value: 'valor_total_previsto', width: '150px' },
        ],
        filters: {
            exercicioFilter: null,
            descricaoFilter: '',
            acaoFilter: '',
            elementoItemFilter: '',
        },
        items: [],
        itemSelected: [],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false,
        filterTimeout: null,
        exerciciosOptions: [],
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            return this.baseHeaders;
        }
    },
    created() {
        this.listarElementosPrimariosGenericosPaginado();
        this.carregarOpcoesFiltros();
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarElementosPrimariosGenericosPaginado();
        }
    },
    methods: {
        async listarElementosPrimariosGenericosPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ElementoPrimarioGenericoService.index(filter);

                if (typeof response !== 'string' && response && response.data) {
                    this.items = response.data.data || [];
                    this.totalItems = response.data.total || 0;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os elementos primários genéricos.');
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os elementos primários genéricos:', error);
                this.items = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async carregarOpcoesFiltros() {
            try {
                const anosResponse = await ElementoPrimarioGenericoService.getAnosOptions();
                if (anosResponse && anosResponse.data) {
                    this.exerciciosOptions = anosResponse.data.map(ano => ({
                        text: String(ano),
                        value: ano
                    }));
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar as opções dos filtros:', error);
            }
        },
        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.exercicioFilter !== null && this.filters.exercicioFilter !== '') {
                filter.append("exercicio", this.filters.exercicioFilter);
            }
            
            if (this.filters.descricaoFilter) {
                filter.append("descricao", this.filters.descricaoFilter);
            }
            
            if (this.filters.acaoFilter) {
                filter.append("acao", this.filters.acaoFilter);
            }
            
            if (this.filters.elementoItemFilter) {
                filter.append("elemento_item", this.filters.elementoItemFilter);
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },
        
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarElementosPrimariosGenericosPaginado();
        },
        
        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text || '-';
            }
            return text.substring(0, maxLength) + '...';
        },

        formatCurrency(value) {
            if (!value && value !== 0) {
                return '-';
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        
        clearFilters() {
            this.filters = {
                exercicioFilter: null,
                descricaoFilter: '',
                acaoFilter: '',
                elementoItemFilter: '',
            };
            this.page = 1;
            this.listarElementosPrimariosGenericosPaginado();
        },
        
        handleFilterChange() {
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.listarElementosPrimariosGenericosPaginado();
            }, 300);
        },

        getRowClass() {
            return 'row-standard';
        }
    }
};

